import { FC } from 'react';
import { SelectTrigger } from '../../../../../Select/components/DesktopSelect/components/SelectTrigger';
import { MultiSelectTriggerProps } from '../../../../types';

export const SelectTriggerCount: FC<MultiSelectTriggerProps> = ({
  value,
  title: titlePrefix,
  placeholder,
  alwaysShowDropdownIcon = true,
  ...props
}) => {
  const count = value.length;
  let title: string;

  if (placeholder != null && count === 0) {
    title = placeholder;
  } else {
    title = titlePrefix ? `${titlePrefix} (${count})` : `(${count})`;
  }

  return (
    <SelectTrigger
      {...props}
      alwaysShowDropdownIcon={alwaysShowDropdownIcon}
      value={count}
      titleOption={{ title }}
    />
  );
};
